import React from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const PlayerSelectionCard = ({ player, isSelected, onToggle, playerTeam, onTeamChange }) => {
  return (
    <div
      className={`w-full rounded-xl border-2 transition-all duration-200 ${
        isSelected
          ? 'border-[var(--color-primary)] bg-orange-50 dark:bg-orange-950/20'
          : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-orange-300'
      }`}
    >
      <button
        onClick={() => onToggle(player?.id)}
        className="w-full text-left p-3 md:p-4 flex items-center gap-3 min-h-[60px]"
        aria-pressed={isSelected}
        aria-label={`${isSelected ? 'Deselect' : 'Select'} ${player?.name}`}
      >
        <div className={`w-5 h-5 rounded flex items-center justify-center flex-shrink-0 border-2 transition-colors ${
          isSelected ? 'bg-[var(--color-primary)] border-[var(--color-primary)]' : 'border-gray-300 bg-white dark:bg-gray-700'
        }`}>
          {isSelected && <Icon name="Check" size={12} color="#fff" strokeWidth={3} />}
        </div>
        <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
          <Image
            src={player?.avatar}
            alt={player?.avatarAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-heading font-semibold text-sm truncate" style={{ color: 'var(--color-foreground)' }}>
            {player?.name}
          </p>
          <p className="font-caption text-xs" style={{ color: 'var(--color-muted-foreground)' }}>
            #{player?.number} · {player?.position}
          </p>
        </div>
      </button>

      {isSelected && (
        <div className="px-3 pb-3 flex gap-2">
          <button
            onClick={() => onTeamChange?.(player?.id, 'Winners')}
            className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg border font-caption text-xs font-semibold transition-all ${
              playerTeam === 'Winners' ?'border-emerald-500 bg-emerald-500 text-white' :'border-[var(--color-border)] bg-[var(--color-muted)] text-[var(--color-muted-foreground)] hover:border-emerald-400'
            }`}
            aria-pressed={playerTeam === 'Winners'}
          >
            <Icon name="Trophy" size={12} color={playerTeam === 'Winners' ? '#fff' : 'currentColor'} />
            Won
          </button>
          <button
            onClick={() => onTeamChange?.(player?.id, 'Losers')}
            className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg border font-caption text-xs font-semibold transition-all ${
              playerTeam === 'Losers' ?'border-red-500 bg-red-500 text-white' :'border-[var(--color-border)] bg-[var(--color-muted)] text-[var(--color-muted-foreground)] hover:border-red-400'
            }`}
            aria-pressed={playerTeam === 'Losers'}
          >
            <Icon name="ThumbsDown" size={12} color={playerTeam === 'Losers' ? '#fff' : 'currentColor'} />
            Lost
          </button>
        </div>
      )}
    </div>
  );
};

export default PlayerSelectionCard;